export const BrandLogo = ({ size = "h-9 w-9", text = "text-2xl", showText = true, testId = "brand-logo", className = "" }) => (
  <span className={`inline-flex items-center gap-3 ${className}`} data-testid={testId}>
    <img src="/logo.png" alt="LoreRight logo" className={`${size} shrink-0 rounded-full object-contain`} />
    {showText && <span className={`font-display ${text} text-[#F3EBDD]`}>LoreRight</span>}
  </span>
);
